import { formatMoney, isAmountAbove, MoneyText } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import { priceSummary, type Product } from './product.ts';
import styles from './PriceTag.module.css';

export const PriceTag = ({ product, size = 'md' }: { product: Product; size?: 'md' | 'lg' }) => {
  const { t, i18n } = useTranslation();
  const summary = priceSummary(product);
  if (summary === null) return <span>—</span>;
  return (
    <span className={[styles['tag'], size === 'lg' ? styles['large'] : ''].join(' ')}>
      <span className={styles['price']}>
        <MoneyText
          money={summary.lowest}
          upTo={isAmountAbove(summary.highest.amount, summary.lowest.amount) ? summary.highest : undefined}
          locale={i18n.language}
        />
      </span>
      {summary.compareAt === null ? null : (
        <s className={styles['compare']}>
          <span className="visually-hidden">{t('productEditor.regularPrice')} </span>
          {formatMoney(summary.compareAt, i18n.language)}
        </s>
      )}
    </span>
  );
};
